import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_atStart2tgdnaxgj04ln as get_atStart,
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atTop15ygil3ceeuhl as get_atTop,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DragShadowu6jlihuvhlhp as DragShadow,
  maxOfNotNullOrNull2k16vysnptiyz as maxOfNotNullOrNull,
  percentComplete22ixcedvdan2 as percentComplete,
  renderPercent3ullukkakwyrl as renderPercent,
  filter31kgiqs90is7g as filter,
  getMany3bs02247im3ra as getMany,
} from '../../../../../utils/utils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { get_dragHandlemufcu3tsewag as get_dragHandle } from '../../../../../icons.mjs';
import { get_unpadded3gipn3ftxgnwh as get_unpadded } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { requiresAction13nb01xm2r5gu as requiresAction } from '../../../../../extensions/FlowPermissions.ext.mjs';
import { NeedsApproval1ftfboe6wlgyi as NeedsApproval } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { isFinal1ds8cwv2a0e8r as isFinal } from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance } from '../../../../screens/common/ProjectView.mjs';
import {
  actionIcon360epyywhabwj as actionIcon,
  escalationIconmtio0lqe8r8o as escalationIcon,
  timerRunningIcon3mra8cwh7awq2 as timerRunningIcon,
  scopeSetIcon1d64me82i5zfn as scopeSetIcon,
} from '../../../iconShortcuts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../../../theming/Titles.mjs';
import { displayState3t6e3fm84zv10 as displayState } from '../../../../../extensions/LineItem.ext.mjs';
import { LineItemStateSemantic242xtb5m8w8mc as LineItemStateSemantic } from '../../../../theming/states.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { priceWithChangedayxt0y21soj as priceWithChange } from '../../../priceChanges.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { LineItemDetailsPage1m0bbf89e2gid as LineItemDetailsPage } from './LineItemDetailsPage.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../../../theming/sections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  maxOrNull2yp8rzwwvng8y as maxOrNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LineItemState_Cancelled_getInstance3kcyrqker8w6h as LineItemState_Cancelled_getInstance } from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { ScopeViewDetailsf9xt7m1tnie as ScopeViewDetails } from './ScopeViewDetails.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function lineItemCard(_this__u8e3s4, item, lens, dragData, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(false);
  var $this$row = view;
  if (!(dragData == null)) {
    var tmp = $this$row.ibb(get_atStart($this$row), get_compact($this$row));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())($this$row.pc());
    var tmp0_elvis_lhs_0 = $this$row.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? $this$row : tmp0_elvis_lhs_0;
    $this$row.ebb(p_0, view_0);
    var tmp_0 = KMutableProperty0();
    var tmp_1 = Frame$_get_dragData_$ref_eesbsj(view_0);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('dragData', 0, tmp_0, tmp_1, Frame$_set_dragData_$ref_14yerl(view_0));
    reactiveScope(view_0, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.baj(dragData).fcy(VOID, VOID, DragShadow($this$row, Align_Start_getInstance(), VOID, get_rem(1)));
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    var tmp_2 = get_centered(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (IconView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.ebu('drag');
    view_1.qbt(get_dragHandle(Companion_getInstance()));
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_2, view_1);
    $this$row.fbb(p_0, view_0);
    $this$row.jbb(tmp, view_0);
  }
  var tmp_3 = $this$row.ibb(get_expanding($this$row), get_unpadded($this$row));
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Link())($this$row.pc());
  var tmp0_elvis_lhs_2 = $this$row.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
  $this$row.ebb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.xbm(true);
  var tmp_4 = get_compact(view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_4.xbm(false);
  var tmp_5 = view_4.ibb(get_atTop(view_4), get_expanding(view_4));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.xbm(false);
  var tmp_6 = get_centered(view_5);
  view_5.jbb(tmp_6, actionIcon(view_5, VOID, ($this$actionIcon) => {
    var line = $this$actionIcon.baj(item);
    var tmp;
    if (!(line.e99() == null)) {
      return null;
    }
    var perms = $this$actionIcon.baj(_this__u8e3s4.mgf()).p3(line.kf9_1);
    var tmp_0 = perms == null ? null : requiresAction(perms);
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (lens.xgj()) {
      var tmp2_safe_receiver = perms == null ? null : perms.x8w();
      var tmp_4 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.f8w();
      tmp_3 = !(tmp_4 == null) ? isInterface(tmp_4, NeedsApproval()) : false;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = !isFinal(line.kfy());
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = ActionImportance_Important_getInstance();
    } else {
      tmp_1 = null;
    }
    return maxOfNotNullOrNull([tmp_0, tmp_1]);
  }));
  var tmp_7 = view_5.ibb(get_centered(view_5), get_expanding(view_5));
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  view_6.jba(view_6.ob6_1.ybe(SubtitleSemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_8 = KMutableProperty0();
  var tmp_9 = TextView$_get_content_$ref_4pzcwl(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp$ret$8 = $this$reactiveScope.baj(item).lf9_1;
    this_1.set(tmp$ret$8);
    return Unit_instance;
  });
  view_5.fbb(p_6, view_6);
  view_5.jbb(tmp_7, view_6);
  view_4.fbb(p_5, view_5);
  view_4.jbb(tmp_5, view_5);
  var tmp_10 = get_atTop(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_7 = view_4.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
  view_4.ebb(p_7, view_7);
  view_7.xbm(false);
  var tmp_11 = get_centered(view_7);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.ebb(p_8, view_8);
  view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_8.zb8(get_dp(5));
  var tmp_12 = KMutableProperty0();
  var tmp_13 = TextView$_get_shown_$ref_kipsub(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('shown', 0, tmp_12, tmp_13, TextView$_set_shown_$ref_l7jsq9(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp$ret$19 = $this$reactiveScope.baj(item).e99() == null;
    this_2.set(tmp$ret$19);
    return Unit_instance;
  });
  dynamicTheme(view_8, ($this$dynamicTheme) => LineItemStateSemantic(displayState($this$dynamicTheme.baj(item))));
  var tmp_14 = KMutableProperty0();
  var tmp_15 = TextView$_get_content_$ref_4pzcwl_0(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb_0(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp$ret$21 = displayState($this$reactiveScope.baj(item)).j9b_1;
    this_3.set(tmp$ret$21);
    return Unit_instance;
  });
  view_7.fbb(p_8, view_8);
  view_7.jbb(tmp_11, view_8);
  var tmp_16 = get_compact(view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_9 = view_7.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
  view_7.ebb(p_9, view_9);
  view_9.xbm(false);
  var tmp_17 = get_centered(view_9);
  view_9.jbb(tmp_17, escalationIcon(view_9, reactive(view_9, ($this$reactive) => {
    var tmp0_safe_receiver = $this$reactive.baj(_this__u8e3s4.mgf()).p3($this$reactive.baj(item).kf9_1);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n8w();
  })));
  view_9.jbb(get_centered(view_9), timerRunningIcon(_this__u8e3s4, view_9, item));
  view_7.fbb(p_9, view_9);
  view_7.jbb(tmp_16, view_9);
  view_4.fbb(p_7, view_7);
  view_4.jbb(tmp_10, view_7);
  view_3.fbb(p_4, view_4);
  view_3.jbb(tmp_4, view_4);
  var tmp_18 = get_compact(view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_10 = view_3.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_3 : tmp0_elvis_lhs_10;
  view_3.ebb(p_10, view_10);
  view_10.xbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.ebb(p_11, view_11);
  view_11.xbm(false);
  view_11.jbb(get_centered(view_11), body(view_11, 'Amount:'));
  var tmp_19 = get_centered(view_11);
  var tmp_20 = ($this$priceWithChange) => new (MonetaryValue())($this$priceWithChange.baj(item).hf9_1.f6l_1);
  view_11.jbb(tmp_19, priceWithChange(view_11, false, tmp_20, ($this$priceWithChange) => {
    // Inline function 'kotlin.let' call
    var it = $this$priceWithChange.baj(item).hf9_1;
    var tmp$ret$41 = MonetaryValue__minus_impl_jw9qyp(it.f6l_1, it.n6k_1);
    return new (MonetaryValue())(tmp$ret$41);
  }));
  view_10.fbb(p_11, view_11);
  var tmp_21 = get_expanding(view_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (Space())(view_10.pc());
  var tmp0_elvis_lhs_12 = view_10.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
  view_10.ebb(p_12, view_12);
  view_10.fbb(p_12, view_12);
  view_10.jbb(tmp_21, view_12);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_13 = view_10.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_10 : tmp0_elvis_lhs_13;
  view_10.ebb(p_13, view_13);
  view_13.xbm(false);
  var paid = remember(VOID, VOID, VOID, ($this$remember) => {
    var line = $this$remember.baj(item);
    var tmp;
    if (!(line.mfy() == null)) {
      return new (MonetaryValue())(line.hf9_1.f6l_1);
    }
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(_this__u8e3s4.hgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.s6v_1.equals(line.kf9_1) && (element.b6w_1 || element.z6v_1 === true)) {
        destination.v(element);
      }
    }
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s_0 = destination.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      var tmp_0 = sum;
      var tmp$ret$52 = element_0.t6v_1;
      sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$52);
    }
    var tmp$ret$53 = sum;
    return new (MonetaryValue())(tmp$ret$53);
  });
  view_13.jbb(get_centered(view_13), body(view_13, '% Complete: '));
  var tmp_22 = get_centered(view_13);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (TextView())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.cbb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.ebb(p_14, view_14);
  view_14.jba(view_14.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_23 = KMutableProperty0();
  var tmp_24 = TextView$_get_content_$ref_4pzcwl_1(view_14);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('content', 0, tmp_23, tmp_24, TextView$_set_content_$ref_pketfb_1(view_14));
  reactiveScope(view_14, ($this$reactiveScope) => {
    var it = $this$reactiveScope.baj(item);
    var tmp;
    if (it.of9_1) {
      tmp = '-';
    } else {
      var price = $this$reactiveScope.baj(item).hf9_1.f6l_1;
      tmp = renderPercent(percentComplete($this$reactiveScope.baj(paid).a5s_1, price), 1);
    }
    var tmp$ret$54 = tmp;
    this_4.set(tmp$ret$54);
    return Unit_instance;
  });
  view_13.fbb(p_14, view_14);
  view_13.jbb(tmp_22, view_14);
  view_10.fbb(p_13, view_13);
  view_3.fbb(p_10, view_10);
  view_3.jbb(tmp_18, view_10);
  view_2.fbb(p_3, view_3);
  var tmp_25 = KMutableProperty0();
  var tmp_26 = Link$_get_to_$ref_jq7esp(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('to', 0, tmp_25, tmp_26, Link$_set_to_$ref_i9gu5x(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var $this$invoke = $this$reactiveScope;
    var tmp$ret$73 = () => new (LineItemDetailsPage())(_this__u8e3s4.jf8(), $this$invoke.baj(item).kf9_1, lens, _this__u8e3s4);
    this_5.set(tmp$ret$73);
    return Unit_instance;
  });
  $this$row.fbb(p_2, view_2);
  $this$row.jbb(tmp_3, view_2);
  writer.fbb(p, view);
  return view;
}
function scopeViewCard(_this__u8e3s4, scope, dragData, writer) {
  // Inline function 'kotlin.with' call
  var tmp = _this__u8e3s4.tgm();
  var items = filter(tmp, ($this$filter, it) => equals(it.nfy(), $this$filter.baj(scope).k7z_1));
  var status = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this$remember.baj(scope).p7z_1) {
      var tmp0 = $this$remember.baj(items);
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.minOfOrNull' call
        var iterator = tmp0.m1();
        if (!iterator.n1()) {
          tmp$ret$0 = null;
          break $l$block;
        }
        var minValue = iterator.o1().kfy();
        while (iterator.n1()) {
          var v = iterator.o1().kfy();
          if (compareTo(minValue, v) > 0) {
            minValue = v;
          }
        }
        tmp$ret$0 = minValue;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = null;
    }
    return tmp;
  });
  var tmp_0 = get_lightSection(writer);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(false);
  var $this$row = view;
  if (!(dragData == null)) {
    var tmp_1 = get_atStart($this$row);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())($this$row.pc());
    var tmp0_elvis_lhs_0 = $this$row.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? $this$row : tmp0_elvis_lhs_0;
    $this$row.ebb(p_0, view_0);
    var tmp_2 = KMutableProperty0();
    var tmp_3 = Frame$_get_dragData_$ref_eesbsj_0(view_0);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('dragData', 0, tmp_2, tmp_3, Frame$_set_dragData_$ref_14yerl_0(view_0));
    reactiveScope(view_0, ($this$reactiveScope) => {
      var tmp$ret$3 = $this$reactiveScope.baj(dragData).fcy(VOID, VOID, DragShadow($this$row, Align_Start_getInstance(), VOID, get_rem(1)));
      this_0.set(tmp$ret$3);
      return Unit_instance;
    });
    var tmp_4 = get_centered(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (IconView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.ebu('drag');
    view_1.qbt(get_dragHandle(Companion_getInstance()));
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_4, view_1);
    $this$row.fbb(p_0, view_0);
    $this$row.jbb(tmp_1, view_0);
  }
  var tmp_5 = $this$row.ibb(get_expanding($this$row), get_unpadded($this$row));
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Link())($this$row.pc());
  var tmp0_elvis_lhs_2 = $this$row.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
  $this$row.ebb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_4.xbm(false);
  var tmp_6 = view_4.ibb(get_expanding(view_4), get_compact(view_4));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.xbm(false);
  var tmp_7 = get_centered(view_5);
  view_5.jbb(tmp_7, actionIcon(view_5, VOID, ($this$actionIcon) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$actionIcon.baj(items);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$11 = item.kf9_1;
      destination.v(tmp$ret$11);
    }
    var ids = destination;
    var tmp = asSequence(getMany($this$actionIcon.baj(_this__u8e3s4.mgf()), ids));
    var tmp0_elvis_lhs = maxOrNull(mapNotNull(tmp, scopeViewCard$lambda$lambda));
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }));
  var tmp_8 = get_centered(view_5);
  view_5.jbb(view_5.ibb(tmp_8, shownWhen(view_5, VOID, ($this$shownWhen) => $this$shownWhen.baj(scope).p7z_1)), scopeSetIcon(view_5, get_rem_0(1.2)));
  var tmp_9 = view_5.ibb(get_centered(view_5), get_expanding(view_5));
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  view_6.jba(view_6.ob6_1.ybe(SubtitleSemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_10 = KMutableProperty0();
  var tmp_11 = TextView$_get_content_$ref_4pzcwl_2(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb_2(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp$ret$14 = $this$reactiveScope.baj(scope).m7z_1;
    this_1.set(tmp$ret$14);
    return Unit_instance;
  });
  view_5.fbb(p_6, view_6);
  view_5.jbb(tmp_9, view_6);
  view_4.fbb(p_5, view_5);
  view_4.jbb(tmp_6, view_5);
  var tmp_12 = get_centered(view_4);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_7 = view_4.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
  view_4.ebb(p_7, view_7);
  view_7.jba(view_7.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_7.zb8(get_dp(5));
  var tmp_13 = KMutableProperty0();
  var tmp_14 = TextView$_get_shown_$ref_kipsub_0(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('shown', 0, tmp_13, tmp_14, TextView$_set_shown_$ref_l7jsq9_0(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp$ret$25 = !($this$reactiveScope.baj(status) == null);
    this_2.set(tmp$ret$25);
    return Unit_instance;
  });
  dynamicTheme(view_7, ($this$dynamicTheme) => {
    var tmp0_safe_receiver = $this$dynamicTheme.baj(status);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = LineItemStateSemantic(tmp0_safe_receiver);
    }
    return tmp;
  });
  var tmp_15 = KMutableProperty0();
  var tmp_16 = TextView$_get_content_$ref_4pzcwl_3(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, TextView$_set_content_$ref_pketfb_3(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.baj(status);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j9b_1;
    var tmp$ret$29 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    this_3.set(tmp$ret$29);
    return Unit_instance;
  });
  view_4.fbb(p_7, view_7);
  view_4.jbb(tmp_12, view_7);
  view_3.fbb(p_4, view_4);
  var tmp_17 = get_compact(view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_8 = view_3.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_3 : tmp0_elvis_lhs_8;
  view_3.ebb(p_8, view_8);
  view_8.xbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.ebb(p_9, view_9);
  view_9.xbm(false);
  view_9.jbb(get_centered(view_9), body(view_9, 'Amount:'));
  var tmp_18 = get_centered(view_9);
  var tmp_19 = ($this$priceWithChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$priceWithChange.baj(items);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$40 = element.v91();
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$40);
    }
    var tmp$ret$41 = sum;
    return new (MonetaryValue())(tmp$ret$41);
  };
  view_9.jbb(tmp_18, priceWithChange(view_9, false, tmp_19, ($this$priceWithChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$priceWithChange.baj(items);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$42 = MonetaryValue__minus_impl_jw9qyp(element.v91(), element.hf9_1.n6k_1);
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$42);
    }
    var tmp$ret$43 = sum;
    return new (MonetaryValue())(tmp$ret$43);
  }));
  view_8.fbb(p_9, view_9);
  var tmp_20 = get_expanding(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Space())(view_8.pc());
  var tmp0_elvis_lhs_10 = view_8.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
  view_8.ebb(p_10, view_10);
  view_8.fbb(p_10, view_10);
  view_8.jbb(tmp_20, view_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_8.pc());
  var tmp0_elvis_lhs_11 = view_8.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_8 : tmp0_elvis_lhs_11;
  view_8.ebb(p_11, view_11);
  view_11.xbm(false);
  var paid = remember(VOID, VOID, VOID, ($this$remember) => {
    var lines = $this$remember.baj(items);
    var draws = $this$remember.baj(_this__u8e3s4.hgt());
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = lines.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp_0;
      if (!(element.mfy() == null)) {
        tmp_0 = element.hf9_1.f6l_1;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s_0 = draws.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          if (element_0.s6v_1.equals(element.kf9_1) && (element_0.b6w_1 || element_0.z6v_1 === true)) {
            destination.v(element_0);
          }
        }
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var sum_0 = Companion_instance.p91(0n);
        var _iterator__ex2g4s_1 = destination.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          var tmp_1 = sum_0;
          var tmp$ret$54 = element_1.t6v_1;
          sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$54);
        }
        tmp_0 = sum_0;
      }
      var tmp$ret$56 = tmp_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$56);
    }
    var tmp$ret$57 = sum;
    return new (MonetaryValue())(tmp$ret$57);
  });
  view_11.jbb(get_centered(view_11), body(view_11, '% Complete: '));
  var tmp_21 = get_centered(view_11);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextView())(view_11.pc());
  var tmp0_elvis_lhs_12 = view_11.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.ebb(p_12, view_12);
  view_12.jba(view_12.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_22 = KMutableProperty0();
  var tmp_23 = TextView$_get_content_$ref_4pzcwl_4(view_12);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('content', 0, tmp_22, tmp_23, TextView$_set_content_$ref_pketfb_4(view_12));
  reactiveScope(view_12, ($this$reactiveScope) => {
    var tmp;
    if (equals($this$reactiveScope.baj(status), LineItemState_Cancelled_getInstance())) {
      tmp = '-';
    } else {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$reactiveScope.baj(items);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp_0 = sum;
        var tmp$ret$58 = element.v91();
        sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$58);
      }
      var price = sum;
      tmp = renderPercent(percentComplete($this$reactiveScope.baj(paid).a5s_1, price), 1);
    }
    var tmp$ret$60 = tmp;
    this_4.set(tmp$ret$60);
    return Unit_instance;
  });
  view_11.fbb(p_12, view_12);
  view_11.jbb(tmp_21, view_12);
  view_8.fbb(p_11, view_11);
  view_3.fbb(p_8, view_8);
  view_3.jbb(tmp_17, view_8);
  view_2.fbb(p_3, view_3);
  var tmp_24 = KMutableProperty0();
  var tmp_25 = Link$_get_to_$ref_jq7esp_0(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('to', 0, tmp_24, tmp_25, Link$_set_to_$ref_i9gu5x_0(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var $this$invoke = $this$reactiveScope;
    var tmp$ret$79 = () => new (ScopeViewDetails())(_this__u8e3s4.jf8(), $this$invoke.baj(scope).k7z_1, _this__u8e3s4.rgj(), _this__u8e3s4);
    this_5.set(tmp$ret$79);
    return Unit_instance;
  });
  $this$row.fbb(p_2, view_2);
  $this$row.jbb(tmp_5, view_2);
  writer.fbb(p, view);
  return writer.jbb(tmp_0, view);
}
function Frame$_get_dragData_$ref_eesbsj(p0) {
  return () => p0.hb9();
}
function Frame$_set_dragData_$ref_14yerl(p0) {
  return (_this__u8e3s4) => {
    p0.gb9(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
function Frame$_get_dragData_$ref_eesbsj_0(p0) {
  return () => p0.hb9();
}
function Frame$_set_dragData_$ref_14yerl_0(p0) {
  return (_this__u8e3s4) => {
    p0.gb9(_this__u8e3s4);
    return Unit_instance;
  };
}
function scopeViewCard$lambda$lambda(it) {
  return requiresAction(it);
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_shown_$ref_kipsub_0(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9_0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Link$_get_to_$ref_jq7esp_0(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x_0(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
//region block: exports
export {
  lineItemCard as lineItemCard17zaiwgczjtrr,
  scopeViewCard as scopeViewCardh4i41xz7rdh8,
};
//endregion

//# sourceMappingURL=cards.mjs.map
